module.exports = __webpack_public_path__ + "img/137.511c657f.jpg";